module.exports = __webpack_public_path__ + "static/NotoKufiArabic-Bold-3ac3ce7a1ac7135735d06139e801f080.woff";